/**
 * Normalizes timezone, aliasing legacy Asia/Calcutta to Asia/Kolkata.
 */
export function normalizeTimezone(tz?: string | null): string {
  if (!tz) return "Asia/Kolkata";
  const trimmed = tz.trim();
  if (trimmed === "Asia/Calcutta") return "Asia/Kolkata";
  return trimmed;
}

/**
 * Returns the browser-detected IANA timezone (e.g. "Asia/Kolkata").
 * Falls back to "Asia/Kolkata" if the API is unavailable.
 */
export function getDetectedTimezone(): string {
  try {
    const detected = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata";
    return normalizeTimezone(detected);
  } catch {
    return "Asia/Kolkata";
  }
}

/**
 * Returns true when the two IANA timezone strings are different.
 */
export function isTimezoneMismatch(selected: string, detected: string): boolean {
  if (!selected || !detected) return false;
  return normalizeTimezone(selected) !== normalizeTimezone(detected);
}
